import { init, addMessages, _ } from 'svelte-i18n';
import { get_user_language_code } from '$lib/lib.js';
import en from '../locales/en.json';
import ru from '../locales/ru.json';
import cs from '../locales/cs.json';
import uk from '../locales/uk.json';

addMessages('en', en);
addMessages('en-US', en);
addMessages('ru', ru);
addMessages('ru-RU', ru);
addMessages('cs', cs);
addMessages('cs-CZ', cs);
addMessages('uk', uk);
addMessages('uk-UA', uk);

// The bot appends "lang" to preview links (see tgbot's miniapp.py). It holds
// the language stored in the database at the time the link was created, which
// is fresher than the localStorage cache, so it takes precedence.
function get_url_language_code() {
  const param = new URLSearchParams(window.location.search).get('lang');
  if (!param) {
    return undefined;
  }
  // Normalize e.g. "cs-cz" to "cs-CZ" to match the registered locales.
  const [base, region] = param.split('-');
  return base.toLowerCase() + (region ? '-' + region.toUpperCase() : '');
}

init({
  fallbackLocale: 'en',
  initialLocale: get_url_language_code() || get_user_language_code(),
});
